/**
 * Per-workspace feature flags, stored in `workspaces.feature_flags` (jsonb
 * string array). Flags gate features that are not yet generally available:
 * the server enforces them and the UI reads them from the workspace row.
 * Toggle with the super-admin `admin.workspaces.setFeatureFlag` procedure.
 */

/** Gates environments, environment Linear routing and spaces (docs/environments.md). */
export const ENVIRONMENTS_FEATURE_FLAG = 'environments'

/** Gates PR risk classification and `risk:*` labels (docs: guides/risk-labels). */
export const RISK_LABELS_FEATURE_FLAG = 'risk_labels'

/** Gates agent friction reports and the friction inbox (docs: guides/friction). */
export const FRICTION_FEATURE_FLAG = 'friction'

export const WORKSPACE_FEATURE_FLAGS = [
  ENVIRONMENTS_FEATURE_FLAG,
  RISK_LABELS_FEATURE_FLAG,
  FRICTION_FEATURE_FLAG,
] as const

export type WorkspaceFeatureFlag = (typeof WORKSPACE_FEATURE_FLAGS)[number]

export interface WorkspaceWithFeatureFlags {
  featureFlags?: readonly string[] | null
}

export function hasWorkspaceFeature(
  workspace: WorkspaceWithFeatureFlags | null | undefined,
  flag: WorkspaceFeatureFlag,
): boolean {
  return workspace?.featureFlags?.includes(flag) ?? false
}
